import React from "react"
// import { Link } from "gatsby"
import { graphql } from "gatsby"
import { BgImage } from "gbimage-bridge"
import ReactMarkdown from "react-markdown"
// import Image from "gatsby-image"
import TopMenu from "../components/TopMenu"
import ContactForm from "../components/ContactForm"
import Footer from "../components/Footer"
import Seo from "../components/Seo"
// import Testimonial from "../components/testimonials/Testimonial"
// import VideoButton from "../components/VideoButton"

export default function PageSolutions({data}) {
  const page = data.strapiPageSolutions;
  const { image, title, subtitle } = page.info;
  // console.warn(page);

  return (
    <div className="">
    <Seo 
      title={(page.seo && page.seo.title) ? page.seo.title : page.title}
      description={(page.seo && page.seo.description) ? page.seo.description : undefined }
      />
        <BgImage image={image.childImageSharp.gatsbyImageData} className="gs-bg-parallax"></BgImage>
        <TopMenu />
          <div className="gs-page-hero gs-scanners-hero">
          <div className="gs-page-hero-img__holder gs-page-hero-img__dummy posr">
            <BgImage image={page.heroImage.childImageSharp.gatsbyImageData} className="gs-page-hero-img__dummy">
              <div className="gs-page-hero-img__dummy"></div>
            </BgImage>
            <div className="gs-header-video__overlay"></div>
          </div>
            <div className="gs-page-hero__in gs-sect__in gs-scanners-hero__in posr z2">
              <div className="gs-container">
                <header className="gs-page-header">
                    <h1 className="gs-page-header-title gs-header-msg--mark">{ title }</h1>
                    <div className="gs-products-item__hr"></div>
                    <h3 className="gs-page-header-subtitle fw300">{ subtitle }</h3>
                </header>
              </div>
            </div>
          </div>

        <section className="gs-color-contrast gs-products-item gs-bg-1 z2">
          <div className="gs-sect__in gs-container gs-container--900">
            <header className="mb3">
            <ReactMarkdown source={page.introText} escapeHtml={false} className="gs-page-content"/>
            </header>            
            </div>
        </section>

        <section className="gs-section-angular gs-section-angular--2 posr z2">
          <div className="gs-sect__in gs-container gs-container--900 ovh">
          <div className="">
            <ReactMarkdown source={page.content} escapeHtml={false} className="gs-page-content"/>
          </div>
            
          </div>
        </section>

          <section className="gs-section-bg gs-section-bg--last">
          {/* <div className="gs-page-hero-img__holder gs-page-hero-img__dummy posr">
            <BackgroundImage fluid={image.childImageSharp.fluid} className="gs-page-hero-img__dummy">
              <div className="gs-page-hero-img__dummy"></div>
            </BackgroundImage>
            <div className="gs-header-video__overlay gs-header-video__overlay--07"></div>
          </div> */}
              <div className="gs-sect__in gs-page-content gs-container gs-container--900 posr z2" id="form">
                <h2 className="mb0">
                  <div className="mb05">Contact us for personal service</div>
                  <div className="gs-products-item__hr"></div>
                </h2>
                <p>
                Are you looking for an easy imaging solution for your pathology system? Or are you interested in practical whole slide imaging scanners to make your lab get results faster and easier? 
                </p>
                <p>
                Get in touch with us to discuss options.
                </p>
                <ContactForm pageName={title} labels={{message: "Describe your imaging needs"}}></ContactForm>
              </div>
          </section>
            <Footer/>
      </div>
  );
}

export const query = graphql`
  {
    strapiPageSolutions {
      id
      seo {
        title
        description
      }
      info {
        title
        subtitle
        slug
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
      heroImage {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      introText
      content
    }
  }
`